import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoachAutomationsPage } from "src/pages/CoachAutomationsPage";
import { automationsQueryOptions } from "src/queries/automations";

const routeSearchSchema = z.object({
  q: z.string().optional(),
});

export const Route = createFileRoute("/_auth/_coach/automations/")({
  component: CoachAutomationsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  async loader({ context }) {
    return context.queryClient.query({
      ...automationsQueryOptions(null),
      staleTime: "static",
    });
  },
});
